import PropTypes from 'prop-types';

import Filters from './Filters';
import Header from '@/modules/AdminTools/components/SettingDataTable/Header';
import FilterRequestDataTable from '@/modules/AdminTools/components/DataTable/FilterRequestDataTable';

const FilterDataTable = ({
  headerOptions,
  filters,
  filterOptions,
  ...props
}) => {
  const hasSetting = props.data?.length > 0;

  return (
    <div>
      <Header {...headerOptions} />
      <hr className="my-8" />
      <Filters {...{ filters, filterOptions }} />
      <hr className="my-8" />
      {hasSetting && (
        <FilterRequestDataTable {...{ ...props }} />
      )}
      {!hasSetting && <div>No data</div>}
    </div>
  );
};

FilterDataTable.propTypes = {
  data: PropTypes.array.isRequired,
  headerOptions: PropTypes.any.isRequired,
  tableOptions: PropTypes.any.isRequired,
  filters: PropTypes.object.isRequired,
  filterOptions: PropTypes.array.isRequired,
};

export default FilterDataTable;
